import { Box, Button, Text } from 'grommet';
import noEyeIcon from '../../../../assets/BoundaryTool/no-eye-icon.svg';
import eyeIcon from '../../../../assets/BoundaryTool/eye-icon.svg';
import { FormDown, FormUp } from 'grommet-icons';
import { useState } from 'react';
import { TrainingRegionItem } from './TrainingRegionItem';
import { useDispatch, useSelector } from 'react-redux';
import { useAppSelector } from '../../../../redux';
import { fitBoundsOption } from '../../../../redux/actions/map-actions/field/field-helper';
import { toggleTrainingVisible } from '../../../../redux/actions/map-actions/map-action';

export const TrainingRegionList = (): JSX.Element => {
  const map = useAppSelector((state) => state.map.map);
  const trainingRegions = useSelector((state: any) => state.map.trainingRegions);
  const showTrainigngRegions = useSelector((state: any) => state.map.showTrainigngRegions);
  const dispatch = useDispatch();

  const [isOpen, setOpen] = useState<boolean>(true);

  return (
    <Box
      direction={'column'}
      pad={'12px 0'}
      margin={'0 0 2rem 0'}
      gap={'small'}
      style={{ minHeight: 'unset', borderBottom: 'solid 1px #ccc', padding: '1rem' }}>
      <Box direction={'row'} gap={'small'}>
        {!showTrainigngRegions ? (
          <Button
            data-cy={`show-field-button`}
            onClick={() => {
              dispatch(toggleTrainingVisible());
            }}>
            <img
              src={noEyeIcon}
              height={24}
              width={24}
              alt='Show Fields Icon'
              style={{
                cursor: 'pointer',
                alignSelf: 'center',
              }}
            />
          </Button>
        ) : (
          <Button
            data-cy={`hide-field-button`}
            onClick={() => {
              dispatch(toggleTrainingVisible());
            }}>
            <img
              src={eyeIcon}
              height={24}
              width={24}
              alt='Hide Fields Icon'
              style={{
                cursor: 'pointer',
                alignSelf: 'center',
              }}
            />
          </Button>
        )}

        <Box
          width={'100%'}
          direction={'row'}
          justify={'between'}
          gap={'16px'}
          height={'30px'}
          onClick={() => {
            setOpen(!isOpen);
          }}>
          <Text data-cy={`unenroll-collapsible-title`} textAlign={'start'} size={'20px'} style={{ fontWeight: 900, color: '#282828' }}>
            Training Regions ({trainingRegions.length})
          </Text>
          <Box direction={'row'} align={'center'}>
            {isOpen ? <FormUp height={'12px'} width={'12px'} /> : <FormDown height={'12px'} width={'12px'} />}
          </Box>
        </Box>
      </Box>
      {isOpen && !!trainingRegions.length && (
        <Box>
          {trainingRegions.map((trainingClass) => (
            <TrainingRegionItem
              focus={(newCenter) => {
                map?.fitBounds([newCenter[0], newCenter[1], newCenter[2], newCenter[3]], fitBoundsOption);
              }}
              trainingClass={trainingClass}
              key={trainingClass.id}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};
